import LinkWithArrow from "@/components/links/LinkWithArrow/LinkWithArrow";
import Skeleton from "@/components/Skeleton/Skeleton";
import Table from "@/components/Table/Table";
import { useGetProduct, useGetProductOrderQuantities } from "@/pages/products/useProducts";
import styles from "./../ProductRelations.module.scss";

export default function ProductOrdeRelations({ productId }: { productId: number }) {
  const { data, isLoading, isFetching } = useGetProductOrderQuantities({ productId });
  const { data: productData } = useGetProduct({ productId });

  return (
    <>
      <div className={[styles.relation, styles.products].join(" ")}>
        <div>
          <h3>Orders</h3>
          <span className={styles.metric}>
            <Skeleton
              loading={isLoading}
              style={{ width: 20, height: 24 }}
            >
              {data?.reduce((acc, curr) => acc + curr.total, 0)}
            </Skeleton>
          </span>
        </div>
      </div>
      <Table
        hideRaster={true}
        loading={isLoading || isFetching}
        pagination={{ page: 1, pageSize: 5 }}
        data={data}
        emptyState={{ noResultsMessage: "Not related to purchase or sales orders." }}
        columns={[
          {
            label: "Year",
            key: "year",
          },
          {
            label: "Purchased",
            key: "po",
            renderer: (record) => (
              <LinkWithArrow
                to={`/orders/purchase_orders?year=${
                  record.year
                }&search_product_external_id=${encodeURI(productData?.product.external_id || "")}`}
              >
                {record.po}
              </LinkWithArrow>
            ),
          },
          {
            label: "Sold",
            key: "so",
            renderer: (record) => (
              <LinkWithArrow
                to={`/orders/sales_orders?year=${
                  record.year
                }&search_product_external_id=${encodeURI(productData?.product.external_id || "")}`}
              >
                {record.so}
              </LinkWithArrow>
            ),
          },
        ]}
        rowKey={"year"}
      />
    </>
  );
}
